import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import Popup from 'Components/Popup'
import React from 'react'
import styles from './styles'

const ReviewPopup = ({ classes, onClose, isOpen }) => {
  if (!isOpen) {
    return null
  }

  return (
    <Popup
      title="Submitted for review"
      onCancel={onClose}
      modalClassName={classes.confirmModal}
      body={
        <div>
          <div className={classes.infoBlock}>
            We will review the information submitted and get back to you as soon
            as possible.
          </div>
          <div className={classes.infoBlock}>
            If everything looks well, we will be ready to start the printing
            process
          </div>
        </div>
      }
      footer={
        <div>
          <Button
            className={cn(classes.button, classes.filledButton)}
            variant="outlined"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      }
    />
  )
}

export default withStyles(styles)(ReviewPopup)
